(function(){
  'use strict';
  if (window.__cwGiftGuard) return;
  window.__cwGiftGuard = true;

  function isCartMut(u){
    if (!u) return false; u = '' + u;
    return u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1;
  }

  // De _cw_gift property bevat de drempel in hele euro. Een cadeau hoort er alleen te zijn
  // zolang het cadeau-subtotaal (cart.total_price minus cadeauwaarde) >= die drempel is.
  // Zakt het eronder, dan halen we het cadeau ECHT uit de cart (qty 0) zodat het ook van de
  // checkout verdwijnt en de klant er nooit voor betaalt. Zelfde maatstaf als de voortgangsbalk.
  function prune(){
    if (window.__cwPruneBusy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var items = cart.items || [];
        var giftCents = 0;
        items.forEach(function(it){ if ((it.properties||{})._cw_gift) giftCents += it.final_line_price; });
        var sub = cart.total_price - giftCents; if (sub < 0) sub = 0;
        var rm = [];
        items.forEach(function(it){
          var k = (it.properties||{})._cw_gift; if (!k) return;
          var need = parseInt(k, 10); if (isNaN(need)) return;
          if (sub < need * 100) rm.push(it.key);
        });
        if (!rm.length) return;
        window.__cwPruneBusy = true;
        var step = function(i){
          if (i >= rm.length){
            window.__cwPruneBusy = false;
            try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch(e){}
            try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); } catch(e){}
            var ci = document.querySelector('cart-items');
            if (ci && typeof ci.refreshCartItems === 'function'){ try { ci.refreshCartItems(); } catch(e){} }
            return;
          }
          fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ id: rm[i], quantity: 0 }) })
            .then(function(){ step(i+1); })
            .catch(function(){ step(i+1); });
        };
        step(0);
      })
      .catch(function(){});
  }

  function schedule(){ setTimeout(prune, 160); }

  if (window.fetch){
    var _f = window.fetch;
    window.fetch = function(){
      var a = arguments;
      var p = _f.apply(this, a);
      try { var u = (a[0] && a[0].url) ? a[0].url : a[0]; if (isCartMut(u)) p.then(schedule).catch(function(){}); } catch(e){}
      return p;
    };
  }
  var _o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){
    try { if (isCartMut(u)) this.addEventListener('load', schedule); } catch(e){}
    return _o.apply(this, arguments);
  };
  document.addEventListener('cart:updated', schedule);

  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', prune); } else { prune(); }
})();